import {AccessRights} from "../../../constants";
import TemplateView from '../../../TemplateView'
import {generatePermissionRows, getGenerateMoneyReportsRightTitle, getManagePtoAndSickDaysRightTitle} from "../../../permissions/PermissionsUtils"

const DUPLICATE_NAME_ERROR = "duplicateNameError"
const EMPTY_NAME_ERROR = "emptyNameError"

export default class PermissionTemplatesView extends TemplateView {
    constructor($containerEl, {
        withoutChoosing = false,
        onSaveButtonClick = () => {},
        onCloseButtonClick = () => {},
    }) {
        super($containerEl);

        this.state = {
            name: '',
            permissions: [],
            dataUpdating: false,
            duplicateName: false,
            emptyName: false,
            templateChanged: false,
            isURAEnabled: false,
            isBTYEnabled: false,
            isPTOEnabled: false,
            isSDBEnabled: false,
            isLTTEnabled: false,
        }

        this.params = {
            withoutChoosing,
            onSaveButtonClick,
            onCloseButtonClick,
        }

        this.saveButtonTitle = (withoutChoosing) ? "userlist.userdata.permissions_templates.edit_mode.save" : "userlist.userdata.permissions_templates.edit_mode.save_and_apply";

        this.onStatePropertyChanged('name', (name) => {
            this.$nameInput.pVal(name);
        });

        this.onStatePropertyChanged('permissions', (permissions) => {
            Object.values(this.permissionRows).map((row) => row.setState({checked: false}));

            for (let permission of permissions) {
                if (this.permissionRows[permission])
                    this.permissionRows[permission].setState({checked: true});
            }
        });

        this.onStatePropertyChanged('emptyName', (emptyName) => {
            this.$el.toggleClass(EMPTY_NAME_ERROR, emptyName)
        })

        this.onStatePropertyChanged('duplicateName', (duplicateName) => {
            this.$el.toggleClass(DUPLICATE_NAME_ERROR, duplicateName);
        });

        this.onAnyStatePropertyChanged(['isURAEnabled', 'isBTYEnabled'], ({isURAEnabled, isBTYEnabled}) => {
            const needToShowGenerateMoneyReport = isURAEnabled || isBTYEnabled
            this.permissionRows[AccessRights.GENERATE_MONEY_REPORTS].toggle(needToShowGenerateMoneyReport)
            this.permissionRows[AccessRights.EDIT_HIERARCHY].setState({lastRow: !needToShowGenerateMoneyReport})

            const permissionTitle = getGenerateMoneyReportsRightTitle(isURAEnabled, isBTYEnabled)
            this.permissionRows[AccessRights.GENERATE_MONEY_REPORTS].setState({name: permissionTitle})
        })

        this.onAnyStatePropertyChanged(['isPTOEnabled', 'isSDBEnabled'], ({isPTOEnabled, isSDBEnabled}) => {
            this.permissionRows[AccessRights.MANAGE_PTO_AND_SICK].toggle(isPTOEnabled || isSDBEnabled)

            this.permissionRows[AccessRights.MANAGE_PTO_AND_SICK].setState({
                name: getManagePtoAndSickDaysRightTitle(isPTOEnabled, isSDBEnabled)
            })
        })

        this.onStatePropertyChanged('isLTTEnabled', (isLTTEnabled) => {
            this.permissionRows[AccessRights.LOCK_TIME_TRACK].toggle(isLTTEnabled)
        })
    }

    templateHtml() {
        return "<div class='permissionsTemplate'>" +
               "    <div class='closeButton'></div>" +
               "    <div class='permissionsTemplateName'>" +
               "        <input type='text' maxlength='191' placeholder='<%=name_placeholder%>' value=''>" +
               "        <div class='duplicateNameErrorMessage'><%=duplicate_name%></div>" +
               "        <div class='emptyNameErrorMessage'><%=empty_name%></div>" +
               "    </div>" +
               "    <div class='permissionGroups'>" +
               "        <div class='firstGroup permissionGroup'/>" +
               "        <div class='secondGroup permissionGroup'/>" +
               "    </div>" +
               "    <div class='templateFooter'>" +
               "        <div class='saveButton'><%=save_and_apply%></div>" +
               "        <div class='resetButton'>" +
               "            <div class='icon'/><div class='label'><%=reset_changes%></div>" +
               "        </div>" +
               "    </div>" +
               "</div>";
    }

    messageKeys() {
        return {
            name_placeholder: "userlist.userdata.permissions_templates.name_placeholder",
            reset_changes: "userlist.userdata.permissions_templates.edit_mode.reset_changes",
            save_and_apply: this.saveButtonTitle,
            duplicate_name: "userlist.userdata.permissions_templates.edit_mode.duplicate_name",
            empty_name: "userlist.userdata.permissions_templates.edit_mode.empty_name"
        }
    }

    afterRender() {
        this.$nameInput = this.find('.permissionsTemplateName input');
        this.$firstGroup = this.find('.firstGroup');
        this.$secondGroup = this.find('.secondGroup');
        this.$saveButton = this.find('.saveButton');
        this.$resetButton = this.find('.resetButton');
        this.$closeButton = this.find('.closeButton')
        this.permissionRows = generatePermissionRows(this.$firstGroup, this.$secondGroup);

        this.permissionRows[AccessRights.GENERATE_MONEY_REPORTS].setState({lastRow: true});
        this.permissionRows[AccessRights.MANAGE_GENERAL_SETTINGS].setState({lastRow: true});


        Object.values(this.permissionRows).map((row) => row.on('changed',
            (e, id, checked) => {
                this._handlePermissionsRowChange(id, checked)
            }));

        this.$saveButton.on('click', () => {
            this.params.onSaveButtonClick(this.getTemplateData())
        })

        //to prevent error processing by menu handlers
        this.getEl().on('mousedown keydown', e => {
            e.stopPropagation()
        })

        this.$closeButton.on('click', () => {
            this.params.onCloseButtonClick()
        })

        this.$nameInput.on('change', (e) => {
            this._handleInputValueChange(e.target.value)
        })

        this.renderInitialState()
    }

    getTemplateData() {
        // need for actualization of state
        this.$nameInput.blur()

        const state = this.getState()
        return {
            name: state.name,
            permissions: state.permissions
        };
    }

    update() {
        Object.values(this.permissionRows).map((row) => row.setState({checked: false}));

        for (let permission of this.state.permissions) {
            if (this.permissionRows[permission])
                this.permissionRows[permission].setState({checked: true});
        }
    }

    _handleInputValueChange = (val) => {
        this.setState({
            name: val,
            duplicateName: false,
            emptyName: false
        })
    }

    _handlePermissionsRowChange = (id, checked) => {
        const newPermissions = this.state.permissions.filter((perm) => perm !== id)
        if (checked) {
            newPermissions.push(id)
        }
        this.setState({
            permissions: newPermissions
        })
    }
}


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/permissionsTemplates/PermissionsTemplateView.js